/* Integration Inbound credential actions */

export const FETCH_ALL_INTEGRATION_CREDENTIALS_START =
  'FETCH_ALL_INTEGRATION_CREDENTIALS_START';
export const FETCH_ALL_INTEGRATION_CREDENTIALS_SUCCESS =
  'FETCH_ALL_INTEGRATION_CREDENTIALS_SUCCESS';
export const FETCH_ALL_INTEGRATION_CREDENTIALS_ERROR =
  'FETCH_ALL_INTEGRATION_CREDENTIALS_ERROR';

export const FETCH_INTEGRATION_CREDENTIAL_SUCCESS =
  'FETCH_INTEGRATION_CREDENTIAL_SUCCESS';

export const CREATE_INTEGRATION_CREDENTIAL_SUCCESS =
  'CREATE_INTEGRATION_CREDENTIAL_SUCCESS';

export const UPDATE_INTEGRATION_CREDENTIAL_SUCCESS =
  'UPDATE_INTEGRATION_CREDENTIAL_SUCCESS';

export const DELETE_INTEGRATION_CREDENTIAL_SUCCESS =
  'DELETE_INTEGRATION_CREDENTIAL_SUCCESS';
